<template>
  <div class="p-4" :class="{ 'bg-neutral-lightest': markBgColor }">
    <!-- @TODO remove this ant-form direct dependency make a component to render form item name and value -->
    <div class="ant-form ant-form-vertical">
      <MRow>
        <MCol :size="4">
          <FlotoFormItem :label="`${$tc('purchase')} ${$t('cost')}`">
            <div
              v-if="
                assetDepreciationInfo.purchaseCost
                  ? assetDepreciationInfo.purchaseCost
                  : costInfo.purchaseAmount
              "
              class="flex"
            >
              {{
                `${
                  assetDepreciationInfo.purchaseCost
                    ? assetDepreciationInfo.purchaseCost
                    : costInfo.purchaseAmount
                }`
              }}
              <CurrencyPicker
                :value="
                  assetDepreciationInfo.currencyId
                    ? assetDepreciationInfo.currencyId
                    : costInfo.currencyId
                "
                text-only
                disabled
              />
            </div>
            <div v-else>---</div>
          </FlotoFormItem>
        </MCol>
        <MCol :size="4">
          <FlotoFormItem :label="`${$t('acquisition_date')}`">
            <span v-if="assetDepreciationInfo.acquitionTime">
              {{ assetDepreciationInfo.acquitionTime | datetime }}
            </span>
            <span v-else>---</span>
          </FlotoFormItem>
        </MCol>
        <MCol :size="4">
          <FlotoFormItem :label="`${$t('depreciation')} ${$t('method')}`">
            {{
              assetDepreciationInfo.depreciationMethod
                ? $tc(assetDepreciationInfo.depreciationMethod)
                : '---'
            }}
          </FlotoFormItem>
        </MCol>
        <MCol :size="4">
          <FlotoFormItem
            :label="`${$tc('useful_life')} ${$tc('or')} ${$tc(
              'depreciation'
            )} ${$tc('percent')}/${$tc('years')}`"
          >
            {{ assetDepreciationInfo.usefulLife || '---' }}
          </FlotoFormItem>
        </MCol>
        <MCol :size="4">
          <FlotoFormItem :label="`${$tc('salvage')} ${$tc('amount')}`">
            <div v-if="assetDepreciationInfo.salvageAmount" class="flex">
              {{ `${assetDepreciationInfo.salvageAmount}` }}
              <CurrencyPicker
                :value="assetDepreciationInfo.currencyId"
                text-only
                disabled
              />
            </div>
            <div v-else>---</div>
          </FlotoFormItem>
        </MCol>
      </MRow>
    </div>
  </div>
</template>

<script>
import CurrencyPicker from '@components/data-picker/currency-picker'
import { OrganizationComputed } from '@state/modules/organization'

export default {
  name: 'AssetDepreciationDetails',
  components: { CurrencyPicker },
  props: {
    // eslint-disable-next-line
    markBgColor: { type: Boolean, default: true },
    assetDepreciationInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    costInfo: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...OrganizationComputed,
  },
}
</script>
